import { RuleDataAccessors } from '../../RuleData';
/**
 *
 * @param activeSourceCategories
 * @param ruleData
 */
export function generateActiveSources(activeSourceCategories, ruleData) {
    return RuleDataAccessors.getSourceData(ruleData).filter((source) => activeSourceCategories.includes(source.sourceCategoryId));
}
